import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/features/auth/stores/use-auth-store'

export function SuperUserGuard() {
  const user = useAuthStore((s) => s.user)

  if (!user?.isSuperUser) {
    return <Navigate to="/projects" replace />
  }

  return <Outlet />
}
